import { render, staticRenderFns } from "./VariablesTable.vue?vue&type=template&id=0b6ed5f1&"
import script from "./VariablesTable.vue?vue&type=script&lang=js&"
export * from "./VariablesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports